import script from "./WorldClocks.vue?vue&type=script&setup=true&lang=js"
export * from "./WorldClocks.vue?vue&type=script&setup=true&lang=js"

import "./WorldClocks.vue?vue&type=style&index=0&id=076badc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-076badc4"]])

export default __exports__